import { MAX_RANGE_VALUE } from '@abb-procure/constants';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSlider, MatSliderRangeThumb } from '@angular/material/slider';
import { MatTooltip } from '@angular/material/tooltip';
import { ToNumberPipe } from '../../pipes/to-number.pipe';
import { shortNumber } from '../../utilities/short-number.util';

export type RangeControls = {
  min: FormControl<number | null>;
  max: FormControl<number | null>;
};

@Component({
  selector: 'procure-input-range',
  templateUrl: './input-range.component.html',
  styleUrl: './input-range.component.scss',
  imports: [
    MatSlider,
    MatSliderRangeThumb,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    MatLabel,
    ToNumberPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputRange {
  readonly max = input<number>(MAX_RANGE_VALUE);
  readonly min = input<number>(0);
  readonly label = input.required<string>();
  readonly group = input.required<FormGroup<RangeControls>>();

  readonly showMode = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly hint = input<string>('');
  readonly step = input<number>(1);

  readonly displayWith = input<(value: number) => string>(
    (value) => `${shortNumber(value)}`,
  );

  protected readonly MAX_RANGE_VALUE = MAX_RANGE_VALUE;
}
